import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [心愿活动主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=161229623
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/act_wish_form_homepage',
  async (p: {mid: number}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/act_wish_form_homepage',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

export const get_act_wish_form_task_award = createAsyncThunk(
  'Saada/live/hiya_socialize/get_act_wish_form_task_award',
  async (p: {task_id: number}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_act_wish_form_task_award',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

interface RankItem {
  mid: number
  rank: string // 排名
  avatar: string // 头像
  name: string // 昵称
  pearl: number
  value: number
}

export interface InitialStateType {
  home?: {
    tasks?: {
      task_id: number
      icon: string // 图标
      title: string // 标题
      pearl: number // 珍珠数量
      task_cur: number // 当前任务数量
      task_need: number // 需要完成的任务数量
      state: 0 | 1 | 2 // 状态：0-进行中, 1-领取, 2-已完成
      link: string // 链接，使用 schema
    }[]
    ranks?: {
      me?: RankItem
      list?: RankItem[]
    }
    count_down?: number // 秒
    reward_config?: {
      ranking: string
      target: number
      value: number
    }[]
    award_type?: 0 | 1 | 2 | 3 // 对应三种盲盒动画, 为0就没有开盲盒流程
    award_value?: number // 开盒后数值
  }
}

const initialState: Partial<InitialStateType> = {
  home: {
    // tasks: [
    //   {
    //     task_id: 1,
    //     icon: 'icon-url-1', // 示例图标链接
    //     title: '10 minus',
    //     pearl: 1000,
    //     task_cur: 10,
    //     task_need: 15,
    //     state: 0, // 进行中
    //     link: 'schema://example1',
    //   },
    //   {
    //     task_id: 2,
    //     icon: 'icon-url-2', // 示例图标链接
    //     title: '20 plus',
    //     pearl: 2000,
    //     task_cur: 20,
    //     task_need: 25,
    //     state: 1, // 领取
    //     link: 'schema://example2',
    //   },
    //   {
    //     task_id: 3,
    //     icon: 'icon-url-3', // 示例图标链接
    //     title: '30 multiply',
    //     pearl: 3000,
    //     task_cur: 30,
    //     task_need: 30,
    //     state: 2, // 已完成
    //     link: 'schema://example3',
    //   },
    // ],
    // ranks: {
    //   me: {
    //     rank: '1',
    //     avatar: 'https://example.com/avatar1.png',
    //     name: 'User One',
    //     pearl: 100,
    //     // dollar: 1500,
    //     value: 5000,
    //     // mid: 101,
    //   },
    //   list: [
    //     {
    //       rank: '1',
    //       avatar: 'https://example.com/avatar1.png',
    //       name: 'User One',
    //       pearl: 100,
    //       value: 5000,
    //       // mid: 101,
    //     },
    //     {
    //       rank: '2',
    //       avatar: 'https://example.com/avatar2.png',
    //       name: 'User Two',
    //       pearl: 80,
    //       // dollar: 1200,
    //       value: 4000,
    //       // mid: 102,
    //     },
    //     {
    //       rank: '3',
    //       avatar: 'https://example.com/avatar3.png',
    //       name: 'User Three',
    //       pearl: 60,
    //       // dollar: 900,
    //       value: 3000,
    //       // mid: 103,
    //     },
    //     {
    //       rank: '4',
    //       avatar: 'https://example.com/avatar4.png',
    //       name: 'User Four',
    //       pearl: 40,
    //       // dollar: 600,
    //       value: 2000,
    //       // mid: 104,
    //     },
    //     {
    //       rank: '5',
    //       avatar: 'https://example.com/avatar5.png',
    //       name: 'User Five',
    //       pearl: 20,
    //       // dollar: 300,
    //       value: 1000,
    //       // mid: 105,
    //     },
    //   ],
    // },
    // count_down: 1000,
    // reward_config: [
    //   {
    //     ranking: '1-5',
    //     target: 1000,
    //     value: 10000,
    //   },
    //   {
    //     ranking: '6-10',
    //     target: 500,
    //     value: 5000,
    //   },
    //   {
    //     ranking: '11-20',
    //     target: 200,
    //     value: 2000,
    //   },
    // ],
    // award_type: 1, // 对应三种盲盒动画, 为0就没有开盲盒流程
    // award_value: 1000, // 开盒后数值
  },
}

export const SaadaWishActivitySlice = createSlice({
  name: 'SaadaWishActivity',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload.data || {list: []}})
    })
  },
})

export default SaadaWishActivitySlice.reducer

export const useSaadaWishActivityState = () => {
  const data = useSelector((state) => {
    return state.SaadaWishActivity
  })
  return data
}
